(function(){if(window.__pp7r)return;window.__pp7r=1;
/* gwp-countdown */
if (!customElements.get('gwp-countdown')) {
    class GwpCountdown extends HTMLElement {
      connectedCallback() {
        this.hoursEl = this.querySelector('[data-unit="hours"]');
        this.minutesEl = this.querySelector('[data-unit="minutes"]');
        this.secondsEl = this.querySelector('[data-unit="seconds"]');
        this.tick();
        this.interval = setInterval(this.tick.bind(this), 1000);
      }
      disconnectedCallback() { clearInterval(this.interval); }
      getTarget() {
        const mode = this.dataset.timerMode;
        const intervalHours = { daily: 24, half_day: 12, quarter_day: 6 }[mode];
        if (intervalHours) {
          const ms = intervalHours * 36e5;
          return new Date((Math.floor(Date.now() / ms) + 1) * ms);
        }
        return new Date(this.dataset.target);
      }
      tick() {
        const diff = this.getTarget() - Date.now();
        if (diff <= 0) {
          this.hoursEl.textContent = '00';
          this.minutesEl.textContent = '00';
          this.secondsEl.textContent = '00';
          return;
        }
        const h = Math.floor(diff / 36e5);
        const m = Math.floor((diff % 36e5) / 6e4);
        const s = Math.floor((diff % 6e4) / 1e3);
        this.hoursEl.textContent = String(h).padStart(2, '0');
        this.minutesEl.textContent = String(m).padStart(2, '0');
        this.secondsEl.textContent = String(s).padStart(2, '0');
      }
    }
    customElements.define('gwp-countdown', GwpCountdown);
  }
/* gwp-gallery */
if (!customElements.get('gwp-gallery')) {
    class GwpGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.gallery-track');
        this.slides = [...this.querySelectorAll('.gallery-slide')];
        this.dots = [...this.querySelectorAll('.gwp-dot')];
        this.prevBtn = this.querySelector('.gallery-btn--prev');
        this.nextBtn = this.querySelector('.gallery-btn--next');
        this.current = 0;
        this.total = this.slides.length;
        this.interval = parseInt(this.dataset.autoplayInterval) || 4000;

        this.prevBtn?.addEventListener('click', () => this.go(this.current - 1));
        this.nextBtn?.addEventListener('click', () => this.go(this.current + 1));
        this.dots.forEach(dot => {
          dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index)));
        });

        this.startAutoplay();

        /* Touch/swipe support */
        let startX = 0;
        this.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', e => {
          const diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) {
            diff > 0 ? this.go(this.current + 1) : this.go(this.current - 1);
          }
        }, { passive: true });
      }

      go(index) {
        this.current = ((index % this.total) + this.total) % this.total;
        this.track.style.transform = `translateX(-${this.current * 100}%)`;
        this.dots.forEach((d, i) => d.classList.toggle('active', i === this.current));
        this.startAutoplay();
      }

      startAutoplay() {
        clearInterval(this._timer);
        this._timer = setInterval(() => this.go(this.current + 1), this.interval);
      }

      disconnectedCallback() {
        clearInterval(this._timer);
      }
    }
    customElements.define('gwp-gallery', GwpGallery);
  }
/* gwp-sticky-cta */
if (!customElements.get('gwp-sticky-cta')) {
    class GwpStickyCta extends HTMLElement {
      connectedCallback() {
        this._init = this._init.bind(this);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._init);
        } else {
          this._init();
        }
      }

      _init() {
        /* ---------- state ---------- */
        this._pastHero  = false;   // true once hero CTA scrolls above viewport
        this._offerVisible = false; // true while product selector is on screen

        /* ---------- hero target ---------- */
        this._heroTarget =
          document.querySelector('.gwp-hero__btn') ||
          document.querySelector('.gwp-hero__cta-wrap') ||
          document.querySelector('.gwp-hero__outer');

        /* ---------- offer / buy-box target ---------- */
        var offerSel = this.dataset.offer || '.gwp-product-selector-section';
        this._offerTarget = document.querySelector(offerSel);

        /* ---------- hero observer ---------- */
        if (!this._heroTarget) {
          // No hero found — assume we're past it
          this._pastHero = true;
          this._update();
        } else {
          this._heroObs = new IntersectionObserver(function(entries) {
            var e = entries[0];
            // Hero CTA is above the viewport → user scrolled past it
            this._pastHero = !e.isIntersecting && e.boundingClientRect.top < 0;
            this._update();
          }.bind(this), { threshold: 0 });

          this._heroObs.observe(this._heroTarget);
        }

        /* ---------- offer observer ---------- */
        if (this._offerTarget) {
          // rootMargin adds 80px cushion top & bottom so the sticky bar
          // hides slightly before the buy-box enters the viewport and
          // reappears slightly after it leaves. On mobile this prevents
          // the bar from overlapping the ATC button.
          this._offerObs = new IntersectionObserver(function(entries) {
            this._offerVisible = entries[0].isIntersecting;
            this._update();
          }.bind(this), { threshold: 0, rootMargin: '80px 0px 80px 0px' });

          this._offerObs.observe(this._offerTarget);
        }
      }

      _update() {
        // Show the bar only when:
        //   1. User has scrolled past the hero CTA   AND
        //   2. The product selector is NOT on screen
        if (this._pastHero && !this._offerVisible) {
          this.classList.add('stuck');
        } else {
          this.classList.remove('stuck');
        }
      }

      disconnectedCallback() {
        if (this._heroObs)  this._heroObs.disconnect();
        if (this._offerObs) this._offerObs.disconnect();
        document.removeEventListener('DOMContentLoaded', this._init);
      }
    }
    customElements.define('gwp-sticky-cta', GwpStickyCta);
  }
/* gwp-review-carousel */
if (!customElements.get('gwp-review-carousel')) {
    class GwpReviewCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.gwp-reviews__track');
        this.slides = [...this.querySelectorAll('.gwp-reviews__card-wrap')];
        this.dots = [...this.closest('.gwp-reviews').querySelectorAll('.gwp-reviews__dot')];
        this.prevBtn = this.closest('.gwp-reviews').querySelector('[data-dir="prev"]');
        this.nextBtn = this.closest('.gwp-reviews').querySelector('[data-dir="next"]');
        this.current = 0;
        this.total = this.slides.length;

        this.prevBtn?.addEventListener('click', () => this.go(this.current - 1));
        this.nextBtn?.addEventListener('click', () => this.go(this.current + 1));
        this.dots.forEach(d => d.addEventListener('click', () => this.go(parseInt(d.dataset.index))));

        let startX = 0;
        this.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', e => {
          const diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 40) diff > 0 ? this.go(this.current + 1) : this.go(this.current - 1);
        }, { passive: true });
      }
      go(i) {
        if (window.innerWidth >= 992) return;
        this.current = Math.max(0, Math.min(i, this.total - 1));
        const slideW = this.slides[0]?.offsetWidth + 16 || 0;
        this.track.style.transform = `translateX(-${this.current * slideW}px)`;
        this.dots.forEach((d, idx) => d.classList.toggle('active', idx === this.current));
      }
    }
    customElements.define('gwp-review-carousel', GwpReviewCarousel);
  }
/* product selector */
(function(){try{(function(){var psCarousels=document.querySelectorAll('[id^="gwp-ps-carousel-"]');psCarousels.forEach(function(carousel){var slidesContainer=carousel.querySelector("[data-ps-carousel-slides]"),dotsContainer=carousel.querySelector("[data-ps-carousel-dots]"),prevBtn=carousel.querySelector("[data-ps-carousel-prev]"),nextBtn=carousel.querySelector("[data-ps-carousel-next]");if(!slidesContainer)return;var slides=slidesContainer.querySelectorAll(".gwp-ps__carousel-slide"),totalSlides=slides.length;if(totalSlides===0)return;var currentSlide=0;function goToSlide(index){if(currentSlide=index,slidesContainer.style.transform="translateX(-"+index*100+"%)",dotsContainer){var dots=dotsContainer.querySelectorAll(".gwp-ps__carousel-dot");dots.forEach(function(d,i2){d.classList.toggle("gwp-ps__carousel-dot--active",i2===index)})}}if(dotsContainer&&totalSlides>1)for(var i=0;i<totalSlides;i++)(function(index){var dot=document.createElement("button");dot.type="button",dot.className="gwp-ps__carousel-dot"+(index===0?" gwp-ps__carousel-dot--active":""),dot.setAttribute("aria-label","Go to slide "+(index+1)),dot.addEventListener("click",function(){goToSlide(index)}),dotsContainer.appendChild(dot)})(i);prevBtn&&prevBtn.addEventListener("click",function(){goToSlide((currentSlide-1+totalSlides)%totalSlides)}),nextBtn&&nextBtn.addEventListener("click",function(){goToSlide((currentSlide+1)%totalSlides)});var startX=0;carousel.addEventListener("touchstart",function(e){startX=e.touches[0].clientX},{passive:!0}),carousel.addEventListener("touchend",function(e){var diff=startX-e.changedTouches[0].clientX;Math.abs(diff)>40&&(diff>0?goToSlide((currentSlide+1)%totalSlides):goToSlide((currentSlide-1+totalSlides)%totalSlides))},{passive:!0})});var qtyCards=document.querySelectorAll(".gwp-ps__qty-card"),atcButton=document.getElementById("gwp-ps-add-to-cart"),atcPriceEl=atcButton?atcButton.querySelector("[data-atc-price]"):null,selectedCheckoutUrl="";function selectCard(card){if(card){qtyCards.forEach(function(c){c.classList.remove("gwp-ps__qty-card--selected");var radio2=c.querySelector(".gwp-ps__radio-outer");radio2&&(radio2.classList.remove("gwp-ps__radio-outer--checked"),radio2.innerHTML="")}),card.classList.add("gwp-ps__qty-card--selected");var radio=card.querySelector(".gwp-ps__radio-outer");radio&&(radio.classList.add("gwp-ps__radio-outer--checked"),radio.innerHTML='<div class="gwp-ps__radio-inner"></div>'),selectedCheckoutUrl=card.getAttribute("data-checkout-url")||"";var priceEl=card.querySelector(".gwp-ps__qty-price");atcPriceEl&&priceEl&&(atcPriceEl.textContent="| "+priceEl.textContent.trim())}}qtyCards.forEach(function(card){card.addEventListener("click",function(){selectCard(this)}),card.addEventListener("keydown",function(e){(e.key==="Enter"||e.key===" ")&&(e.preventDefault(),selectCard(this))})});var sizeButtons=document.querySelectorAll(".gwp-ps__size-btn");function applySizeMeta(btn){btn&&qtyCards.forEach(function(card,i){var metaEl=card.querySelector("[data-qty-meta]");if(metaEl){var val=btn.getAttribute("data-meta-"+(i+1));val&&val.trim()!==""?metaEl.textContent=val:metaEl.textContent=metaEl.getAttribute("data-default-meta")||""}})}sizeButtons.forEach(function(btn){btn.addEventListener("click",function(){sizeButtons.forEach(function(b){b.classList.remove("gwp-ps__size-btn--active")}),this.classList.add("gwp-ps__size-btn--active"),applySizeMeta(this)})});var initialCard=document.querySelector(".gwp-ps__qty-card--selected")||qtyCards[0];initialCard&&selectCard(initialCard);var initialSize=document.querySelector(".gwp-ps__size-btn--active")||sizeButtons[0];initialSize&&applySizeMeta(initialSize);var psRoot=document.querySelector(".gwp-ps"),atcError=document.getElementById("gwp-ps-atc-error");function showAtcError(msg){atcError&&(atcError.textContent=msg,atcError.removeAttribute("hidden"))}function clearAtcError(){atcError&&(atcError.setAttribute("hidden",""),atcError.textContent="")}function buildCheckoutUrl(baseUrl){if(!psRoot)return baseUrl;var code=(psRoot.getAttribute("data-discount-code")||"").trim();if(!code)return baseUrl;var style=psRoot.getAttribute("data-discount-param")||"query";if(style==="path")return"/discount/"+encodeURIComponent(code)+"?redirect="+encodeURIComponent(baseUrl);var sep=baseUrl.indexOf("?")===-1?"?":"&";return baseUrl+sep+"discount="+encodeURIComponent(code)}atcButton&&atcButton.addEventListener("click",function(){if(clearAtcError(),!selectedCheckoutUrl){showAtcError("Please choose a package.");return}var idleLabel=atcButton.getAttribute("data-atc-idle-label")||"Add to Cart",labelEl=atcButton.querySelector(".gwp-ps__atc-label"),spinnerEl=atcButton.querySelector(".gwp-ps__atc-spinner");atcButton.setAttribute("aria-busy","true"),labelEl&&(labelEl.textContent="Redirecting..."),atcPriceEl&&(atcPriceEl.textContent=""),spinnerEl&&spinnerEl.removeAttribute("hidden"),window.location.assign(buildCheckoutUrl(selectedCheckoutUrl))}),window.addEventListener("pageshow",function(event){if(event.persisted&&atcButton){atcButton.setAttribute("aria-busy","false");var labelEl=atcButton.querySelector(".gwp-ps__atc-label"),spinnerEl=atcButton.querySelector(".gwp-ps__atc-spinner");labelEl&&(labelEl.textContent=atcButton.getAttribute("data-atc-idle-label")||"Add to Cart"),spinnerEl&&spinnerEl.setAttribute("hidden","");var sel=document.querySelector(".gwp-ps__qty-card--selected");if(sel&&atcPriceEl){var p=sel.querySelector(".gwp-ps__qty-price");p&&(atcPriceEl.textContent="| "+p.textContent.trim())}}})})()}catch(e){console.error(e)}})()


/* refill checkbox */
;(function(){var box=document.querySelector('.gwp-ps__refill');var root=document.querySelector('.gwp-ps');if(!box||!root)return;var cards=[].slice.call(document.querySelectorAll('.gwp-ps__qty-card'));var sub=box.querySelector('.gwp-ps__refill-sub');var ttl=box.querySelector('.gwp-ps__refill-title');
function num(s){var n=parseFloat(String(s||'').replace(/[^0-9.]/g,''));return isNaN(n)?0:n;}
cards.forEach(function(c){var p=c.querySelector('.gwp-ps__qty-price');if(p)c.setAttribute('data-sub-price',p.textContent.trim());var cm=c.querySelector('.gwp-ps__qty-compare s');if(cm)c.setAttribute('data-sub-compare',cm.textContent.trim());});
function pct(p,cm){return(cm>p&&p>0)?Math.floor((1-p/cm)*100):0;}
function show(el,on){if(el)el.style.display=on?'':'none';}
function prices(c,on){var pe=c.querySelector('.gwp-ps__qty-price'),ce=c.querySelector('.gwp-ps__qty-compare'),cs=ce&&ce.querySelector('s'),be=c.querySelector('.gwp-ps__discount-badge');var op=c.getAttribute('data-otp-price'),oc=c.getAttribute('data-otp-compare'),ou=c.getAttribute('data-otp-url');var subP=c.getAttribute('data-sub-price'),subC=c.getAttribute('data-sub-compare');
var price=(!on&&op)?op:subP;var comp=on?subC:oc;if(pe)pe.textContent=price;var n=pct(num(price),num(comp));if(cs&&comp)cs.textContent=comp;show(ce,!!comp&&n>0);if(be){if(n>0)be.textContent='You save '+n+'%';show(be,n>0);}c.setAttribute('data-checkout-url',(!on&&ou)?ou:(c.getAttribute('data-sub-url')||''));}
function title(){if(!ttl||!box.classList.contains('is-checked'))return;var tpl=ttl.getAttribute('data-tpl')||'';var sel=document.querySelector('.gwp-ps__qty-card--selected')||cards[cards.length-1];var n=sel?pct(num(sel.getAttribute('data-sub-price')),num(sel.getAttribute('data-sub-compare'))):0;if(n>0)ttl.textContent=tpl.replace('[pct]',n);}
function apply(on){root.classList.toggle('gwp-ps--otp',!on);box.classList.toggle('is-checked',on);box.setAttribute('aria-checked',on?'true':'false');sub.textContent=(on||!box.getAttribute('data-off-text'))?box.getAttribute('data-on-text'):box.getAttribute('data-off-text');cards.forEach(function(c){prices(c,on);});var sel=document.querySelector('.gwp-ps__qty-card--selected')||cards[cards.length-1];if(sel)sel.click();}
function toggle(){apply(!box.classList.contains('is-checked'));}
box.addEventListener('click',toggle);box.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){e.preventDefault();toggle();}});
cards.forEach(function(c){c.addEventListener('click',title);prices(c,true);});title();})();
})();
